import React, {ReactNode} from "react";

interface LiveblogGameSummaryGroupProps {
  children: ReactNode
}

export function LiveblogGameSummaryGroup({children}: LiveblogGameSummaryGroupProps) {
  return <>{children}</>
}
